import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { ApplicationRef, inject, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, Observable, throwError } from "rxjs";

function runInZone<T>(source: Observable<T>, zone: NgZone, appRef: ApplicationRef): Observable<T> {
  const scheduleTick = () => {
    queueMicrotask(() => {
      try {
        appRef.tick();
      } catch {
        // no-op
      }
    });
  };
  return new Observable<T>((observer) => {
    const sub = source.subscribe({
      next: (value) => zone.run(() => {
        observer.next(value);
        scheduleTick();
      }),
      error: (err) => zone.run(() => {
        observer.error(err);
        scheduleTick();
      }),
      complete: () => zone.run(() => {
        observer.complete();
        scheduleTick();
      })
    });
    return () => sub.unsubscribe();
  });
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const zone = inject(NgZone);
  const appRef = inject(ApplicationRef);
  const token = localStorage.getItem("smartbirds_access_token");
  const requiresAdminToken = req.url.includes("/api/v1/admin") || req.url.includes("/api/v1/devices") || req.url.includes("/api/v1/auth/me");

  if (!token || !requiresAdminToken) {
    return runInZone(next(req), zone, appRef);
  }

  const cloned = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });

  return runInZone(next(cloned), zone, appRef).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 || error.status === 403) {
        localStorage.removeItem("smartbirds_access_token");
        localStorage.removeItem("smartbirds_role");
        localStorage.removeItem("smartbirds_permissions");
        localStorage.removeItem("smartbirds_username");
        localStorage.removeItem("smartbirds_display_name");
        localStorage.removeItem("smartbirds_avatar_url");
        router.navigateByUrl("/login");
      }
      return throwError(() => error);
    })
  );
};
